<template>
<div class="cutomer-per">
  <el-table
    :data="listData"
    :empty-text="$t('root.noData')"
    size="small"
    style="width: 100%;"
    :sort-change="sortChange"
    :header-cell-style="{ background: '#F3F2F7',color: '#5E5873' }"
    class="small-el-table"
  >
    <el-table-column
      prop="id"
      :label="$t('serial_number_num')"
    />
    <el-table-column
      :label="$t('Straight_off')"
    >
      <template
        slot-scope="scope"
      >
        <div>{{scope.row.custName}}</div>
        <div>{{scope.row.custId}}</div>
      </template>

    </el-table-column>
    <el-table-column
      :label="`${$t('Total_deposit')} (USD)`"
      sortable
      prop="deposit"
    >
    </el-table-column>
    <el-table-column
      :label="`${$t('Total_withdrawal')} (USD)`"
      sortable
      prop="withdraw"
    >
    </el-table-column>
    <el-table-column
      :label="`${$t('net_deposit')} (USD)`"
      sortable
      prop="netDeposit"
    >
    </el-table-column>
    <el-table-column
      :label="$t('Home.forexVolume')"
      sortable
      prop="volume"
    >
    </el-table-column>
    <el-table-column
      :label="`${$t('commission_contribution')}(USD)`"
      sortable
      prop="commission"
    >
    </el-table-column>
  </el-table>
  <div class="pagination-outer" v-if="total">
    <div class="paginnation-left">
      <size-change @sizeChange="sizeChange"></size-change>
      <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
    </div>
    <vs-pagination
      class="pagination-box"
      :max="max"
      :total="pageSize"
      v-model="page"
    ></vs-pagination>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import {parseTime, getIsMoreThreeMonth } from '@/utils/index';

// 表格字段需要重新调
import initData from "@/mixins/initData";
export default {
  name: "index",
  props: {
    timeDate: {
    },
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {
    timeDate(newValue){
      this.page = 1;
      this.init();
    },
  },
  mounted(){
    this.init();
  },
  methods: {
    beforeInit(){
      this.url = '/crm/reception/partner/performanceStatistics';
      this.params = {
        page: this.page -1,
        size: this.size,
        custType: 2,
      }
      if(this.timeDate && this.timeDate.length){
        if(getIsMoreThreeMonth(this.timeDate[0],this.timeDate[1])){
          this.$message({
            type: 'error',
            message: this.$t('A_maximum_of_three_months_can_be_queried')
          })
          return false;
        }else {
          this.params.startTime = this.timeDate[0];
          this.params.endTime = this.timeDate[1];
        }
      }else {
        this.$message({
          type: 'error',
          message: this.$t('Please_select_a_time')
        })
        return false;
      }
      return true;
    },
  },
}
</script>

<style scoped>

</style>
